import { useQuery } from 'react-query';
import { Compulsory } from 'ts-toolbelt/out/Object/Compulsory';
import { LimitedSchemaQueryOptions } from '@frontend/react-query-helpers';
import { SchemaDigitalForms } from '../../service';
import { IO } from '../../types';
import { defaultOptions } from '../config';
import { requestKeys } from '../keys';

export const useGetSubmissionDetailsForPerson = <E = unknown, T = IO.GetSubmissionDetailsForPerson['output']>(
  req: Compulsory<IO.GetSubmissionDetailsForPerson['input'], 'companyId' | 'person'>,
  options?: LimitedSchemaQueryOptions<IO.GetSubmissionDetailsForPerson, E, T>
) => {
  const queryKey = requestKeys.submissionDetailsForPerson(req);
  const query = useQuery({
    queryKey,
    queryFn: () => SchemaDigitalForms.GetSubmissionDetailsForPerson(req),
    staleTime: 0,
    enabled: !!req.companyId && !!req.person,
    ...defaultOptions,
    ...options,
  });
  return {
    queryKey,
    ...query,
  };
};

export const useGetSubmissionDetailsById = <E = unknown, T = IO.GetSubmissionDetailsById['output']>(
  req: Compulsory<IO.GetSubmissionDetailsById['input'], 'submissionId' | 'companyId'>,
  options?: LimitedSchemaQueryOptions<IO.GetSubmissionDetailsById, E, T>
) => {
  const queryKey = requestKeys.getSubmissionDetailsById(req);
  const query = useQuery({
    queryKey,
    queryFn: () => SchemaDigitalForms.GetSubmissionsById(req),
    staleTime: 1000 * 60 * 20, // 20 mins
    enabled: !!req.companyId && !!req.submissionId,
    ...defaultOptions,
    ...options,
  });
  return {
    queryKey,
    ...query,
  };
};
